export default {
  namespaced: true,
  state: {
    searchHistory: '',
    currentPageHistory: null,
    perPageHistory: null,
    selectedPartnerHistory: null,
    dateRangeHistory: null,
    filledPlatformsHistory: [],
    spendingRangeHistory: {
      min: null,
      max: null,
    },
    accountTypeHistory: null,
  },
  mutations: {
    UPDATE_SEARCH_HISTORY(state, text) {
      state.searchHistory = text
    },
    UPDATE_PAGE_HISTORY(state, value) {
      state.perPageHistory = value
    },
    UPDATE_CURRENT_PAGE_HISTORY(state, value) {
      state.currentPageHistory = value
    },
    UPDATE_SELECTED_PARTNER_HISTORY(state, value) {
      state.selectedPartnerHistory = value
    },
    UPDATE_DATE_RANGE_HISTORY(state, value) {
      state.dateRangeHistory = value
    },
    UPDATE_FILLED_PLATFORMS_HISTORY(state, value) {
      state.filledPlatformsHistory = value
    },
    UPDATE_SPENDING_RANGE_HISTORY(state, value) {
      state.spendingRangeHistory = value
    },
    UPDATE_ACCOUNT_TYPE_HISTORY(state, value) {
      state.accountTypeHistory = value
    },
  },
  actions: {
    updateSearchHistory({ commit }, text) {
      commit('UPDATE_SEARCH_HISTORY', text)
    },
    updatePageHistory({ commit }, value) {
      commit('UPDATE_PAGE_HISTORY', value)
    },
    updateCurrentPageHistory({ commit }, value) {
      commit('UPDATE_CURRENT_PAGE_HISTORY', value)
    },
    updateSelectedPartnerHistory({ commit }, value) {
      commit('UPDATE_SELECTED_PARTNER_HISTORY', value)
    },
    updateDateRangeHistory({ commit }, value) {
      commit('UPDATE_DATE_RANGE_HISTORY', value)
    },
    updateFilledPlatformsHistory({ commit }, value) {
      commit('UPDATE_FILLED_PLATFORMS_HISTORY', value)
    },
    updateSpendingRangeHistory({ commit }, value) {
      commit('UPDATE_SPENDING_RANGE_HISTORY', value)
    },
    updateAccountTypeHistory({ commit }, value) {
      commit('UPDATE_ACCOUNT_TYPE_HISTORY', value)
    },
  },
}
